<template>
  <div class="home">
    <div>
      <img alt="Vue logo" src="../assets/logo.png" />
    </div>
Maybe a sign-in-with-slack button here?
    <a
      :href="signInWithSlackUrl"
    >
      <img
        alt="Sign in with Slack"
        height="40"
        width="172"
        src="https://platform.slack-edge.com/img/sign_in_with_slack.png"
        srcset="https://platform.slack-edge.com/img/sign_in_with_slack.png 1x, https://platform.slack-edge.com/img/sign_in_with_slack@2x.png 2x"
      />
    </a>
    <HelloWorld msg="Find your coworkers" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {
    HelloWorld
  },
  data() {
    return { };
  },
  computed: {
    signInWithSlackUrl: function() {
      console.log(process.env)
      console.log(process.env.VUE_APP_SLACK_CLIENT_ID)
      console.log(process.env.VUE_APP_REDIRECT_URI)
      return `https://slack.com/oauth/authorize?scope=identity.basic`
      + `&client_id=${process.env.VUE_APP_SLACK_CLIENT_ID}`
      + `&redirect_uri=${process.env.VUE_APP_REDIRECT_URI}`;
    }
  }
};
</script>
